import { IconProps } from "../../types/genereal";
import { IconWrapper } from "../ui/IconWrapper";

export const IndustryIcon = ({
  width = "14",
  height = "14",
  color = "#797979",
}: IconProps) => {
  return (
    <IconWrapper width={width} height={height}>
      <svg
        width={width}
        height={height}
        viewBox="0 0 14 14"
        fill="none"
        xmlns="http://www.w3.org/2000/svg"
      >
        <path
          d="M3.26732 9.80004V10.7334H5.13398V9.80004H3.26732ZM3.26732 7.93337V8.86671H7.93398V7.93337H3.26732ZM6.06732 9.80004V10.7334H7.93398V9.80004H6.06732ZM8.86732 7.93337V8.86671H10.734V7.93337H8.86732ZM8.86732 9.80004V10.7334H10.734V9.80004H8.86732ZM2.33398 11.6667V5.13337L4.66732 7.00004V5.13337L7.00065 7.00004V5.13337L9.33398 7.00004L9.80065 2.33337H11.2007L11.6673 7.00004V11.6667H2.33398Z"
          fill={color}
        />
      </svg>
    </IconWrapper>
  );
};
